export const isFile = (value: unknown): value is File => value instanceof File;
